import React from 'react';
import Drawer from '@material-ui/core/Drawer';

const styles = {
  headingContainer: {
    display: 'flex',
    flex: '1 30px',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: 10
  },
  button: {
    background: 'none',
    border: 0,
    outline: 'none'
  }
};

export default ({
  children, open, onClose, heading, containerPadding = { padding: '25px' }, fullHeight = false, ZIndex = 1300, height = '', maxHeight = '',
  hideCloseButton = false, BackdropProps = false, headingPadding = { padding: '0px' }, showHeader = true, backgroundColor = '#f6f6f6',
}) => (
  <Drawer
    open={open}
    anchor="bottom"
    transitionDuration={{ enter: 400, exit: 400 }}
    BackdropProps={{ invisible: BackdropProps, }}
    PaperProps={{
      style: {
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        width: '100%',
        height: fullHeight ? '95%' : height,
      }
    }}
    ModalProps={{ style: { position: 'absolute', zIndex: ZIndex } }}
    onClose={onClose}
  >
    <div style={{ ...containerPadding, backgroundColor: backgroundColor, height: '100%', maxHeight: maxHeight }}>
      {showHeader && (<div style={{ ...styles.headingContainer, ...headingPadding }}>
        <h5>{heading}</h5>
        {!hideCloseButton && <button onClick={onClose} style={styles.button}>
          <img width="14" height="14" src={'/icons/ic_close.jpg'} alt="Close" />
        </button>}
      </div>)}
      {children}
    </div>
  </Drawer >
);
